// Temporary - update according to the supported cities. Currently static but can be replaced with
// reading all the cities from the DB. 
const supportedCities = [
    { name: 'New York', country: 'US' },
    { name: 'London', country: 'UK' },
    { name: 'Berlin', country: 'Germany' },
    { name: 'Los Angeles', country: 'US' },
    { name: 'Chicago', country: 'US' },
    { name: 'Tel Aviv', country: 'Israel' },
    { name: 'Barcelona', country: 'Spain' },
    { name: 'Sydney', country: 'Australia' },
    { name: 'Paris', country: 'France' },
    { name: 'Bangkok', country: 'Thailand' },
    { name: 'Bucharest', country: 'Romania' },
    { name: 'Mexico City', country: 'Mexico' },


    // ... more cities
  ];

  const citiesWithImages = supportedCities.map(city => {
    const imageCityName = city.name.replace(/\s/g, '').toLowerCase();
    const imageUrl = `Specialty%20Coffee%2Flocation_${imageCityName}.jpg`;
    return { ...city, imageUrl: imageUrl }; 
  });
  
export { supportedCities, citiesWithImages}